import ArrowRounded from "@homeinstead/icons/ArrowRounded";
import { motion } from "motion/react";
import { Button } from "~care/components/ui/Button/Button";

const STEPPER_STATUS_ID = "stepper-status";

const Stepper = ({
  currentStep,
  totalSteps,
  showBackButton,
  handleBack,
  className,
  ariaLabel,
}: {
  currentStep: number;
  totalSteps: number;
  showBackButton: boolean;
  handleBack: () => void;
  className?: string;
  /**
   * Accessible name for the progress bar. If not provided, the "Step X of Y" text is used.
   */
  ariaLabel?: string;
}) => {
  if (totalSteps < 1 || currentStep < 0) {
    console.error(
      "Invalid stepper configuration, the following must evaluate to false:",
      `totalSteps < 1: ${totalSteps < 1}`,
      `currentStep < 0: ${currentStep < 0}`,
    );
    throw new Error("Invalid stepper configuration.");
  }
  return (
    <div className={className}>
      <div className="h-2 w-full rounded-full bg-gray">
        <motion.div
          animate={{ width: `${(100 * currentStep) / totalSteps}%` }}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabel ? undefined : STEPPER_STATUS_ID}
          aria-valuemax={totalSteps}
          aria-valuemin={0}
          aria-valuenow={currentStep}
          className="h-2 rounded-full bg-success"
          initial={{ width: 0 }}
          role="progressbar"
          transition={{ duration: 0.5, ease: "easeInOut" }}
        ></motion.div>
      </div>
      <div
        className={`mt-2 mb-10 flex items-center ${showBackButton ? "justify-between" : "justify-end"} font-bold text-sm`}
      >
        {showBackButton && (
          <Button
            className="flex h-5 w-fit gap-1 p-0 px-1 hover:outline-none"
            onClick={handleBack}
            type="button"
            variant="plain"
          >
            <>
              <ArrowRounded className="h-[12px]" />
              <span className="text-sm">Back</span>
            </>
          </Button>
        )}
        <span className="h-5" id={STEPPER_STATUS_ID}>
          Step {currentStep} of {totalSteps}
        </span>
      </div>
    </div>
  );
};

export default Stepper;
